{
  "heading": "Category",
  "none": "None",
  "untitled": "Untitled category",
  "edit": "Edit Category",
  "reorder": "Reorder category",
  "edit_tooltip": "Add a label, edit, or delete",
  "add_category_label": "Add category",
  "cancel_label": "Cancel",
  "back_label": "Back",
  "remove_label": "Remove",
  "delete_confirm": "I'm sure!",
  "new_category": "New Category",
  "remove_success": "Category removed",
  "update_error": "Error saving category",
  "delete_error": "Error deleting category",
  "form_name": "Category name",
  "form_color": "Color",
  "form_save": "Save",
  "form_cancel": "Cancel",
  "form_category_maxlength": "Category name cannot exceed {{max}} characters",
  "form_category_placeholder": "Try \"friends and family\""
}
